// Head of the card of a public legal page: the page's h1 (brand colour, as the card titles of the landing page)
// and, optionally, a line under it. Styles: styles/shared/_legal_page.scss.
const LegalTitle = ({ id, title, lead }) => (
  <div className="legal_card_head">
    <h1 id={id} className="legal_title">
      {title}
    </h1>
    {lead ? <p className="legal_lead">{lead}</p> : null}
  </div>
);

export default LegalTitle;
